<template>
    <div class="input-custom-component" :class="{'has-clear': clearable}">
        <el-input size="medium" v-model="inputValue" :placeholder="placeholder"></el-input>
        <i v-if="inputValue" @click="inputValue = ''" class="clear-icon el-icon-circle-close"></i>
    </div>
</template>
<script type="text/javascript">
    export default {
        name: 'InputCustom',
        props: {
            value: [String, Number],
            clearable: {type: Boolean, default: true},
            placeholder: {type: String, default: '请输入'}
        },
        data () {
            return {
                inputValue: this.value
            }
        },
        watch: {
            value: function (newValue) {
                this.inputValue = newValue
            },
            inputValue: function (newValue) {
                this.$emit('input', newValue)
            }
        }
    }
</script>
<style type="text/css" lang="scss">
    @import "~variable";

    .input-custom-component {
        position : relative;
        > .clear-icon {
            display  : none;
            position : absolute;
            right    : 5px;
            top      : 11px;
            color    : $text-color-third;
        }
        &.has-clear {
            .clear-icon {
                display : block;
            }
            .el-input__inner {
                padding-right : 20px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// main.vue?6e38a6b5